import { render, staticRenderFns } from "./ContentBlockEmbedo.vue?vue&type=template&id=16e27d34&"
import script from "./ContentBlockEmbedo.vue?vue&type=script&lang=js&"
export * from "./ContentBlockEmbedo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports